import React from 'react';

import { FormattedMessage } from 'react-intl';
import { Button } from '@tink/core/src/components/atoms/Button/Button';

import { PageView, UserInteractionEvent } from '../../../../../../../models/analytics';
import { PendingAuthenticationScreen } from '../PendingAuthenticationScreen/PendingAuthenticationScreen';
import { usePageViewEvents } from '../../../../../../../core/Analytics/usePageViewEvents';
import { BackButton } from '../../../../../../organisms/Header/HeaderMolecule';
import { messages } from './messages';

export type AwaitingMobileBankIdAuthenticationLocalPromptViewProps = {
  isPay: boolean;
  onOpenBankId: VoidFunction;
} & BackButton;

export const AwaitingMobileBankIdAuthenticationLocalPromptView = ({
  isPay,
  onOpenBankId,
  onBack,
}: AwaitingMobileBankIdAuthenticationLocalPromptViewProps) => {
  const { sendViewInteractionEvent } = usePageViewEvents({
    pageView: PageView.BANKID_LOCAL_AWAITING_SCREEN,
  });
  const onOpenBankIdWithAnalytics = () => {
    sendViewInteractionEvent({ interaction: UserInteractionEvent.OPEN_BANKID });
    onOpenBankId();
  };

  return (
    <PendingAuthenticationScreen
      title={
        isPay ? (
          <FormattedMessage {...messages.paymentHeader} />
        ) : (
          <FormattedMessage {...messages.authorizeHeader} />
        )
      }
      primaryText={<FormattedMessage {...messages.instructions} />}
      secondaryText={<FormattedMessage {...messages.bankIDinfo} />}
      primaryButton={
        <Button onClick={onOpenBankIdWithAnalytics}>
          <FormattedMessage {...messages.retry} />
        </Button>
      }
      onBack={onBack}
    />
  );
};
